import type { ConstValues } from '@openx/types/helpers.ts';

export const AudienceDetailsTabsValues = {
  Details: 'details',
  Criteria: 'criteria',
  Insights: 'insights',
};

export type AudienceDetailsTabs = ConstValues<typeof AudienceDetailsTabsValues>;

export function isAudienceDetailsTab(value: unknown): value is AudienceDetailsTabs {
  return Object.values(AudienceDetailsTabsValues).includes(value as AudienceDetailsTabs);
}
